const ROOT_KEY = 'personalization'

export const personalizationKeys = {
  all: [ROOT_KEY] as const,
  experiments: (accountId: string) =>
    [ROOT_KEY, 'experiments', accountId] as const,
  filters: [ROOT_KEY, 'filters'] as const,
  selectedFilters: [ROOT_KEY, 'selectedFilter'] as const,
  graphs: [ROOT_KEY, 'graphs'] as const,
}
